import { Clock, Sparkles, Rocket } from 'lucide-react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const ComingSoon = () => {
  // Create animated background stars
  const createStars = () => {
    return [...Array(20)].map((_, i) => (
      <div
        key={i}
        className="absolute bg-white/10 rounded-full animate-pulse"
        style={{
          left: `${Math.random() * 97}%`,
          top: `${Math.random() * 97}%`,
          width: `${Math.random() * 4 + 1}px`,
          height: `${Math.random() * 4 + 1}px`,
          animationDelay: `${Math.random() * 2}s`,
          animationDuration: `${Math.random() * 3 + 2}s`
        }}
      />
    ));
  };

  useEffect(() => {
    // Save previous overflow values
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevBodyOverflow;  
      document.documentElement.style.overflow = prevHtmlOverflow;
    };
  }, []);

  return (
    <div className="relative min-h-[60vh] flex items-center justify-center overflow-hidden h-screen relative">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {createStars()}
      </div>
      {/* Main content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto w-full text-center py-20">
          {/* Logo/Icon */}
          <div className="mb-8 flex justify-center">
            <div className="bg-gradient-to-r from-pink-500 to-purple-500 p-4 rounded-full shadow-2xl animate-bounce">
              <Rocket className="w-12 h-12 text-white" />
            </div>
          </div>

          {/* Main heading */}
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 bg-clip-text text-transparent animate-pulse">
            Coming Soon
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed">
            I'm working on it (probably). Come back later to see the project!
          </p>

          {/* Social icons */}
          <div className="flex justify-center gap-6 text-gray-400 mb-12">
            <Clock className="w-6 h-6 transition-colors duration-300 cursor-pointer hover:text-pink-500" />
            <Sparkles className="w-6 h-6 transition-colors duration-300 cursor-pointer hover:text-purple-500" />
            <Rocket className="w-6 h-6 transition-colors duration-300 cursor-pointer hover:text-blue-500" />
          </div>

          {/* Progress bar */}
          <div className="max-w-lg mx-auto mb-8">
            <div className="flex justify-between text-sm text-gray-400 mb-2">
              <span>Development Progress</span>
              <span>10%</span>
            </div>
            <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden">
              <div 
                className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all duration-1000 ease-out"
                style={{ width: '10%' }}
              />
            </div>
          </div>
          {/* Back to Projects button */}
          <Link
            to="/projects"
            className="inline-block mt-4 px-6 py-3 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white font-semibold shadow-lg hover:scale-105 transition-all duration-300 animate-pulse "
          >
            ← Back to Projects
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;